module.exports = __webpack_public_path__ + "static/img/logo.a266b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 42
// module chunks = 1